export enum TransactionStatusEnum {
  APPROVED = 'Approved',
  PENDING = 'Pending',
  DECLINED = 'Declined',
}
